import { Component, computed, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { TopNavbarUserMenuComponent } from '../top-navbar/user-menu/top-navbar-user-menu';
import {
  ShellNavStep,
  ShellSidebarMenuEntry,
  ShellSidebarMenuGroup,
  ShellSidebarMenuItem,
} from './sidebar.models';

export type {
  ShellNavStep,
  ShellSidebarMenuEntry,
  ShellSidebarMenuGroup,
  ShellSidebarMenuItem,
} from './sidebar.models';

@Component({
  selector: 'ui-sidebar',
  imports: [NzIconModule, NzMenuModule, TopNavbarUserMenuComponent],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class SidebarComponent {
  private readonly router = inject(Router);

  brandName = input('Company');
  logoPath = input('');
  logoMiniPath = input('');
  menuConfig = input<ShellSidebarMenuEntry[]>([]);
  userName = input('');
  logoutRequested = output<void>();

  readonly hasMenuConfig = computed(() => this.menuConfig().length > 0);

  navSteps = input<ShellNavStep[]>([]);
  currentStep = input<string>('');
  completedSteps = input<Set<string>>(new Set());
  navigate = output<string>();

  isGroup(entry: ShellSidebarMenuEntry): entry is ShellSidebarMenuGroup {
    return entry.type === 'group';
  }

  isActiveRoute(route: string): boolean {
    return this.router.isActive(route, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  hasActiveChild(group: ShellSidebarMenuGroup): boolean {
    return group.children.some(item => this.isActiveRoute(item.route));
  }

  onMenuNavigate(item: ShellSidebarMenuItem): void {
    if (item.enabled === false) {
      return;
    }
    this.router.navigateByUrl(item.route);
  }

  onLogoutRequested(): void {
    this.logoutRequested.emit();
  }

  onNavigate(step: ShellNavStep): void {
    if (step.enabled) {
      this.navigate.emit(step.id);
    }
  }

}
